// extracted by mini-css-extract-plugin
module.exports = {"htmlBlockContainer":"HTMLBlock_htmlBlockContainer__Zwiv0","editTitle":"HTMLBlock_editTitle__TCYE9"};